export default "__VITE_ASSET__sUdF$jTQ__"